<template>
	<van-row class="unpaid-fee-container">
		<div class="content">
			<div v-if="!loading && $utils.isEmpty(cardList)" class="empty-block">
				<span>{{ emptyText }}</span>
			</div>
			<charge-card :selectList="selectList" v-for="(item, index) in cardList" :key="index" :item="item"></charge-card>
		</div>
		<div class="footer">
			<submit-bar :checkAll="checkAll" :money="price" @submit="onClickButton" @select-all="onChange"></submit-bar>
		</div>
		<van-overlay :show="loading" @click="loading = false">
			<div style="display: flex; align-items: center; justify-content: center; height: 100%" @click.stop>
				<van-loading vertical>{{ loadingText }}</van-loading>
			</div>
		</van-overlay>
		<!--        <van-submit-bar :price="price" button-text="去交费" @submit="onClickButton">-->
		<!--            <van-checkbox-->
		<!--                    :value="checkAll"-->
		<!--                    checked-color="#005423"-->
		<!--                    @click="onChange"-->
		<!--                    class="check-box"-->
		<!--            >全选-->
		<!--            </van-checkbox>-->
		<!--        </van-submit-bar>-->
	</van-row>
</template>
<script>
import log from 'utils/log'
import eventBus from './eventbus.js'
import apiUnpaidFee from 'api/unpaid-fee'
import chargeCard from './components/charge-card/index'
import submitBar from '@/views/unpaid-fee/components/submit-bar/index'
// import {setState} from "utils/state";
import storage from 'good-storage'
import utils from '@/utils/util'
import db from '@/utils/db'
import { Overlay } from 'vant'

export default {
	name: 'unpaidFee',
	components: {
		submitBar,
		chargeCard
	},
	data() {
		return {
			price: 0,
			checkAll: false,
			cardList: [],
			// originCardList: [],
			selectList: [],
			code: '',
			loading: false,
			emptyText: this.$t('unpaid_fee.emptyText'),
			loadingText: this.$t('unpaid_fee.loading'),
			cancel_success: this.$t('unpaid_fee.cancel_success')
		}
	},

	created() {
		this.code = this.$route.query.code
		this.getCardList()
		eventBus.$on('summary-price', this.onSummaryPrice)
	},
	activated() {
		this.getCardList()
	},
	methods: {
		onChange() {
			this.checkAll = !this.checkAll
			if (this.checkAll) {
				// this.selectList = this.cardList
				this.selectList = this.cardList.filter(item => !item.isLock) // 20200728 过滤掉锁定的项目
				// this.price = this.selectList.reduce((pre, cur)=> pre + cur.nowMoney * 100, 0)
				this.price = this.selectList.reduce((pre, cur) => pre + cur.nowMoney, 0)
			} else {
				this.selectList = []
				this.price = 0
			}
			eventBus.$emit('select-all', this.checkAll)
		},
		onClickButton() {
			console.log('this.selectList----', this.selectList)
			if (this.selectList.length > 0) {
				let enableUseCompanyTitle = true
				let list = this.selectList.map(x => {
					let item = {
						arrearId: x.arrearId,
						nowMoney: x.nowMoney,
						itemId: x.itemId,
						itemName: x.itemName,
						intervalId: x.intervalId,
						intervalName: x.intervalName
					}
					enableUseCompanyTitle = enableUseCompanyTitle && x.enableUseCompanyTitle
					return item
				})
				let param = {
					allMoney: Number(this.price.toFixed(2)),
					pendFees: list,
					enableUseCompanyTitle: enableUseCompanyTitle
				}
				console.log('param----', param)
				// 检查未付款的接口
				apiUnpaidFee
					.check(param)
					.then(res => {
						if (utils.isNotEmpty(res.data)) {
							//后端对enableUseCompanyTitle有另外的判断修改
							enableUseCompanyTitle = res.data.enableUseCompanyTitle
							let obj = {
								name: 'pay-confirm',
								query: {
									type: 1,
									enableUseCompanyTitle
								}
							}
							// setState('pay-ticket', res.data)
							storage.session.set('pay-ticket', res.data)
							this.$router.push(obj)
						}
					})
					.catch(res => {
						console.log(res)
						if (res.code === 5001) {
							this.handleNextStep(res)
						}
					})
			} else {
				this.$notify({
					type: 'warning',
					message: this.$t('message.selectFee')
				})
			}
		},

		handleNextStep(res) {
			console.log(res)
			this.$dialog
				.alert({
					title: this.$t('pay_confirm.tips'),
					message: this.$t('pay_confirm.tips_content'),
					showCancelButton: true,
					cancelButtonText: this.$t('pay_confirm.cancel_order'),
					confirmButtonText: this.$t('pay_confirm.continue_order')
				})
				.then(() => {
					//点击确认按钮后的调用
					console.log('toPay:' + apiUnpaidFee.payPage)
					const currentLang = db.get('sys.public.language.value').value() || 'zh'
					console.log('currentLang:' + currentLang)
					if (utils.isWxWorkBrowser()) {
						location.href = apiUnpaidFee.payPage + '?orderno=' + res.data[0] + '&scene=wxwork&lang=' + currentLang
					} else if (utils.isWeChatBrowser()) {
						location.href = apiUnpaidFee.payPage + '?orderno=' + res.data[0] + '&scene=wx&lang=' + currentLang
					} else {
						const url = apiUnpaidFee.payPage + '?orderno=' + res.data[0] + '&scene=mobile&lang=' + currentLang
						console.log('url:' + url)
						location.href = url
					}
				})
				.catch(() => {
					//点击取消按钮后的调用
					console.log('cancelPay')
					let param = {
						operateCode: 'CANCEL_PAY',
						orderNo: res.data[0]
					}
					apiUnpaidFee.operate(param).then(res => {
						console.log(res)
						if (res.code === 200) {
							this.$notify({
								type: 'success',
								message: this.cancel_success
							})
						}
					})
				})
		},

		getCardList() {
			let self = this
			self.loading = true
			apiUnpaidFee
				.list({ code: this.code })
				.then(res => {
					console.log('this.cardList----', this.cardList)
					self.loading = false
					this.cardList = res.data || []
				})
				.catch(err => {
					self.loading = false
				})
		},

		onSummaryPrice({ item, checked }) {
			log('item, checked', item, checked)
			let money = item.nowMoney
			if (checked) {
				let index = this.selectList.findIndex(x => x.arrearId === item.arrearId)
				if (index >= 0) {
					this.price = this.selectList.reduce((pre, cur) => pre + Number(cur.nowMoney), 0)
				} else {
					this.price += money
					this.selectList.push(item)
				}
			} else {
				this.price -= money
				let rowIndex = 0
				for (; rowIndex < this.selectList.length; rowIndex++) {
					let row = this.selectList[rowIndex]
					if (row.arrearId === item.arrearId) {
						break
					}
				}
				this.selectList.splice(rowIndex, 1)
			}
			this.checkAll = this.selectList.length === this.cardList.length
		}
	}
}
</script>
<style lang="scss" scoped></style>
